/** Terms — LOTE M. URL: /terms */
import { useEffect, useState } from 'react';
import { useWww } from './_layout';
import { wwwTheme, wwwFonts } from '@/src/website/theme';
import { SeoHead } from '@/src/website/SeoHead';

// Web equivalent of RN's useWindowDimensions().
function useWindowDimensions() {
  const [size, setSize] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  }));
  useEffect(() => {
    const onResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return size;
}

export default function Terms() {
  const { t, lang } = useWww();
  const { width } = useWindowDimensions();
  const isMobile = width < 760;
  const sections = [
    { t: t.termsEligibilityTitle, b: t.termsEligibilityBody },
    { t: t.termsAccountTitle, b: t.termsAccountBody },
    { t: t.termsLicenseTitle, b: t.termsLicenseBody },
    { t: t.termsContentTitle, b: t.termsContentBody },
    { t: t.termsSubscriptionTitle, b: t.termsSubscriptionBody },
    { t: t.termsCancelTitle, b: t.termsCancelBody },
    { t: t.termsLiabilityTitle, b: t.termsLiabilityBody },
    { t: t.termsTerminationTitle, b: t.termsTerminationBody },
    { t: t.termsLoopTitle, b: t.termsLoopBody },
    { t: t.termsLoopProhibitedTitle, b: t.termsLoopProhibitedBody },
    { t: t.termsLawTitle, b: t.termsLawBody },
    { t: t.termsContactTitle, b: t.termsContactBody },
  ];

  // Web replacement for <Stack.Screen options={{ title: ... }} />: update
  // document.title so the browser tab matches the string the native screen
  // header used in the Expo version. Runs after SeoHead's effect so it has
  // the final word, exactly as in the original render order.
  useEffect(() => {
    document.title = t.termsTitle + ' · STILGIA';
  }, [t.termsTitle]);

  return (
    <>
      <SeoHead page="terms" locale={lang} />

      <div style={{ paddingLeft: isMobile ? 24 : 48, paddingRight: isMobile ? 24 : 48, paddingTop: 64, paddingBottom: 80, maxWidth: 820, width: '100%', marginLeft: 'auto', marginRight: 'auto', boxSizing: 'border-box' }}>
        <h1 style={{ color: wwwTheme.text, fontFamily: wwwFonts.serifBold, fontSize: isMobile ? 32 : 46, marginTop: 0, marginBottom: 0 }}>{t.termsTitle}</h1>
        <p style={{ color: wwwTheme.muted, fontSize: 12, letterSpacing: '1px', marginTop: 12, marginBottom: 0, textTransform: 'uppercase' }}>{t.termsLastUpdated}</p>
        <p style={{ color: wwwTheme.text, fontSize: 16, lineHeight: '26px', marginTop: 28, marginBottom: 0 }}>{t.termsIntro}</p>
        {sections.map((s, i) => (
          <div key={i} style={{ marginTop: 36 }}>
            <h2 style={{ color: wwwTheme.text, fontSize: 22, fontWeight: 600, marginTop: 0, marginBottom: 12, fontFamily: wwwFonts.serifBold }}>{s.t}</h2>
            <p style={{ color: wwwTheme.muted, fontSize: 15, lineHeight: '24px', marginTop: 0, marginBottom: 0, whiteSpace: 'pre-line' }}>{s.b}</p>
          </div>
        ))}
      </div>
    </>
  );
}
